import * as React from 'react';
import '../css/index.css';
import { UserContext } from "../components/user_Context";
import { FcGoogle } from "react-icons/fc";
import { BsGithub } from "react-icons/bs";

interface Props {
  profile: any
  provider: string
  onLogout: () => void
}

export const ThisUser = React.memo(({ provider, profile, onLogout }: Props) => {
  const { user, setUser } = React.useContext(UserContext);
  var provIcon;
  const avatar =
    profile?.avatar ||
    profile?.profile_image_url ||
    profile?.avatar_url ||
    profile?.picture ||
    profile?.picture?.data?.url ||
    profile?.profile_image_url_https;

  const setLocalUser = (profile: any) => {
    localStorage.setItem("given_name", profile.given_name);
    localStorage.setItem("family_name", profile.family_name);
    localStorage.setItem("handle", profile.handle);
    localStorage.setItem("email", profile.email);
    localStorage.setItem("provider", provider);
    localStorage.setItem("avatar_url", profile.picture);
    localStorage.setItem("id", profile.id);
    localStorage.setItem("token", profile.token);
  }

  setUser(profile);
  setLocalUser(profile);

  if (provider === "Google") {
    provIcon = <FcGoogle />;
  } else if (provider === "GitHub") {
    provIcon = <BsGithub />;
  }

  return (

    <div className='user-card'>
      <div>
        <img className='avt' alt='user' src={avatar} />
        <div className='provider'>{provIcon}</div>
      </div>
      <div className='content'>
        <div className='data'>
          <div className='name'>{profile.given_name} {profile.family_name}</div>
          <div className='handle'>{profile.handle !== "null" ? profile.handle : ""}</div>
          <div className='email'>{profile.email !== "null" ? profile.email : ""}</div>
        </div>
      </div>
      <button className='btnLogout' onClick={onLogout}>
        Logout
      </button>
    </div>

  )
});